export default __webpack_public_path__ + "static/media/Passcodegenerator.928027e6.png";